export interface CompanySignUpDto {
  phoneNumber?: string;
  companyName?: string;
  numberOfEmployees?: CompanyNumberOfEmployees;
  perceivedProductValuePropostion?: string;
  numberOfUnitsOverseeing?: number;
}

export enum CompanyNumberOfEmployees {
  OneTo50 = '1-50',
  FiftyOneTo200 = '51-200',
  TwoHundredOneTo2000 = '201-2000',
  TwoThousandPlus = '2000+',
}

export const companyNumberOfEmployeesOptions: CompanyNumberOfEmployees[] = [
  CompanyNumberOfEmployees.OneTo50,
  CompanyNumberOfEmployees.FiftyOneTo200,
  CompanyNumberOfEmployees.TwoHundredOneTo2000,
  CompanyNumberOfEmployees.TwoThousandPlus,
];
